import type { ExtractionStage } from '../../../api/listeners/document-extraction'

const terminalPartStatuses = new Set(['succeeded', 'failed', 'cancelled', 'expired'])

/** Results are complete before the server finishes cleaning up its OCR jobs. */
export const isExtractionTransferReady = (stage: ExtractionStage | null): boolean => {
    if (!stage || !stage.parts.length) return false
    if (stage.status === 'succeeded' || stage.status === 'failed') return true
    if (stage.status !== 'running') return false
    return stage.parts.every(part => terminalPartStatuses.has(part.status)
        && (part.status !== 'succeeded' || !!part.result))
}
